import React, { useState, useLayoutEffect } from 'react';
import cn from "classnames";
import style from "./common.module.scss";
import CustomDatePicker from '../shared/date-picker/Date';
import CalendarIcon from '../shared/icons/CalendarIcon';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import {t} from "i18next";

const AnalyticsByTransportType = ({ item, startDate, setStartDate, endtDate, setEndtDate }) => {
    const formatMonth = (monthString) => {
        const [month, year] = monthString.split('.');
        const date = new Date(year, month - 1);
        return date.toLocaleString('ru-RU', { month: 'short' });
    };

    useLayoutEffect(() => {
        let root = am5.Root.new('chartdiv-transport');
        root.setThemes([am5themes_Animated.new(root)]);

        root._logo.dispose();

        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                layout: root.verticalLayout,
                wheelY: "zoomX",
            })
        );

        chart.set("wheelable", true);

        const formattedData = item.map(i => ({
            ...i,
            month: formatMonth(i.month),
        }));

        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: 'month',
                renderer: am5xy.AxisRendererX.new(root, {
                    minGridDistance: 30,
                }),
            })
        );
        xAxis.data.setAll(formattedData);

        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererY.new(root, {}),
            })
        );

        const colors = {
            awning: am5.color(0xD85140),
            covered: am5.color(0x84C08C),
            isothermal: am5.color(0xEDB7B0),
            refrigerator: am5.color(0x5383EC),
        };

        const createSeries = (name, field, color) => {
            let series = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name: name,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    categoryXField: 'month',
                    valueYField: field,
                    stacked: true,
                })
            );

            series.columns.template.setAll({
                // cornerRadiusTL: 16,
                // cornerRadiusTR: 16,
                fill: color,
                stroke: color,
                tooltipText: '{name}: {valueY}',
            });

            series.data.setAll(formattedData);
        };

        createSeries('Рефрижератор', 'refrigerator', colors.refrigerator);
        createSeries('Тент', 'awning', colors.awning);
        createSeries('Крытый', 'covered', colors.covered);
        createSeries('Изотерм', 'isothermal', colors.isothermal);

        return () => {
            root.dispose();
        };
    }, [item]);

    return (
        <div className={style.content}>
            <div className={style.filter}>
                <span className={style.filter_title}>{t('analytics.transportType')}</span>

                <div className={style.filter_date}>
                    <CustomDatePicker
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('analytics.pickDate')}
                        withBorder
                        IconStart={<CalendarIcon />}
                        selected={startDate}
                        onChange={(date) => {
                            setStartDate(date);
                            console.log(date);
                        }}
                    />

                    <CustomDatePicker
                        dateFormat="dd.MM.yyyy"
                        placeholderText={t('analytics.pickDate')}
                        withBorder
                        IconStart={<CalendarIcon />}
                        selected={endtDate}
                        onChange={(date) => {
                            setEndtDate(date);
                            console.log(date);
                        }}
                    />
                </div>
            </div>

            <div className={style.area}>
                <div id="chartdiv-transport" className={style.area_chart}></div>
                <div className={style.area_names}>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <div className={style.area_icon} style={{ backgroundColor: '#5383EC' }} ></div>
                        <div className={style.area_type}>{t('analytics.refrigerator')}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <div className={style.area_icon} style={{ backgroundColor: '#D85140' }}></div>
                        <div className={style.area_type}>{t('analytics.tent')}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <div className={style.area_icon} style={{ backgroundColor: '#58A65C' }}></div>
                        <div className={style.area_type}>{t('analytics.covered')}</div>
                    </div>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <div className={style.area_icon} style={{ backgroundColor: '#EDB7B0' }}></div>
                        <div className={style.area_type}>{t('analytics.isotherm')}</div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default AnalyticsByTransportType;
